import React, { useState } from "react";
import { CancelIcon, ConfirmIcon, ICON_SIZE } from "./actionIcons";
import ReactDOM from "react-dom";
import { Theme } from "@radix-ui/themes";
import { PencilLine } from "lucide-react";
import ModalTitleBar from "./ModalTitleBar";

/**
 * The house prompt dialog (recipe: docs/MODAL_STYLE.md) — a MessageBox with a
 * textarea. OK resolves with the entered text, Cancel with "CANCEL".
 */
const TextBox = ({ title, onClick }) => {
    const [text, setText] = useState("");
    const handleClick = (button) => {
        if (onClick) onClick(button);
    };
    const handleChange = ({ target }) => {
        setText(target.value);
    };
    return ReactDOM.createPortal(
        <Theme>
            <div className="pointer-events-auto fixed inset-0 z-[9999] flex items-center justify-center">
                <div className="absolute inset-0" style={{ background: "rgba(15, 23, 42, 0.55)" }} />
                <div
                    className="relative w-full max-w-md mx-4 overflow-hidden"
                    style={{
                        background: "var(--theme-surface)",
                        borderRadius: "var(--theme-radius-lg)",
                        boxShadow: "var(--theme-shadow-dialog)"
                    }}
                    role="dialog"
                    aria-modal="true"
                >
                    {title && <ModalTitleBar icon={PencilLine} title={title} />}
                    <div className="modal-body-padded">
                        <textarea
                            className="input-t"
                            style={{ height: 110, padding: "10px 12px", resize: "vertical" }}
                            onChange={handleChange}
                            value={text}
                            autoFocus
                        />
                    </div>
                    <div className="modal-shell-footer">
                        <button
                            type="button"
                            className="btn-t btn-t-secondary"
                            onClick={() => handleClick("CANCEL")}
                        ><CancelIcon size={ICON_SIZE} />
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="btn-t btn-t-primary"
                            onClick={() => handleClick(text)}
                        ><ConfirmIcon size={ICON_SIZE} />
                            OK
                        </button>
                    </div>
                </div>
            </div>
        </Theme>,
        document.body
    );
};

export default TextBox;
